"use strict";
/**
 * 数据表格模块
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var webconfig = require('../../../config/web.js');
var pager_1 = __importDefault(require("../pager"));
/**
 * 三种排序类型的切换
 * @param thistype
 */
function getSortType(thistype) {
    var backtype = '';
    switch (thistype) {
        case 'default':
            backtype = 'desc';
            break;
        case 'desc':
            backtype = 'asc';
            break;
        case 'asc':
            backtype = 'default';
            break;
    }
    return backtype;
}
/**
 * 判断是否需要第一层thead
 * @param config
 */
function isFixThead(config) {
    var back = false;
    config.config.forEach(function (v) {
        if (v.theadfix != undefined) {
            back = true;
        }
    });
    return back;
}
/**
 * 计算接下来有几个相同的theadfix
 * @param config
 * @param configindex
 */
function getSameTheadFix(config, configindex) {
    if (configindex >= config.length - 1) {
        return 1;
    }
    var count = 1;
    var theadfix_val = config[configindex].theadfix;
    for (var index = configindex + 1; index < config.length; index++) {
        if (theadfix_val == config[index].theadfix) {
            count++;
        }
        else {
            break;
        }
    }
    return count;
}
var datatable = /** @class */ (function () {
    function datatable(options) {
        this.table_type = '';
        this.div_id = '';
        this.thissort = ''; //排序字段
        this.this_sort_type = 'default'; //排序类型
        this.thisindex = 1; //当前页数
        this.enabled_pager = true; //是否翻页
        this.pager_id = '';
        this.tablepager = null; //分页示例
        this.floathead = false; //是否开启头部固顶
        this.tableclass = 'table-model';
        this.curSortItem = '';
        this.curSortParam = '';
        this.onShowComplete = null;
        this.initsearch = false;
        this.loadscroll = false;
        this.loadingImg = false;
        this.initdata = false;
        this.initdataLab = 'initdata'; //该字段为首页缓存在页面赋值的字段,默认'initdata'
        this.initdataone = false;
        this.tablecolumns = {};
        this.tabledataurl = {};
        this.postUrl = false;
        this.webhostname = '';
        this.table_type = options.table_type;
        this.div_id = options.div_id;
        this.enabled_pager = options.enabled_pager != undefined ? options.enabled_pager : true; //是否开启翻页功能
        this.pageNoName = options.pageNoName;
        this.pager_id = options.pager_id;
        this.floathead = options.floathead != undefined ? options.floathead : false; //默认false
        this.tableclass = options.tableclass != undefined ? options.tableclass : 'table-model';
        this.onShowComplete = options.onShowComplete || null;
        this.loadscroll = options.loadscroll || false;
        this.loadingImg = options.loadingImg || false;
        this.initdata = options.initdata || false;
        this.initdataLab = options.initdataLab || 'initdata';
        this.initdataone = options.initdataone || false;
        // 是否是post请求
        this.postUrl = options.postUrl || false;
        var initParams = options.initParams || false;
        // 获取table的config和theadfix，入口已配置，用入口的，入口没有配置，用dataconfig文件里面的
        this.tablecolumns = options.columns ? options.columns : (tableconfigdatas ? tableconfigdatas.tablecolumns[this.table_type] : {});
        // 获取table的dataurl，入口已配置，用入口的，入口没有配置，用dataurl文件里面的
        this.tabledataurl = options.dataurl ? options.dataurl : (tableconfigdatas ? tableconfigdatas.tabledataurl[this.table_type] : {});
        // 获取数据的hostname，没有取默认的‘dataurl’，dataurl在webconfig里面表示的是研报api的host
        this.webhostname = this.tabledataurl.hostname ? this.tabledataurl.hostname : (options.dataurl ? (options.dataurl.hostname ? options.dataurl.hostname : 'dataurl') : 'dataurl');
        if (initParams) {
            this.search(initParams);
        }
        else {
            this.init();
        }
        if (this.floathead) {
            var _this_1 = this;
            setTimeout(function () {
                _this_1.makeFloatHead();
            }, 1000);
        }
    }
    datatable.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this;
            return __generator(this, function (_a) {
                _this = this;
                _this.showTable({});
                return [2 /*return*/];
            });
        });
    };
    datatable.prototype.showTable = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this, loadhtml, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _this = this;
                        $('#' + _this.div_id).css({ 'position': 'relative' });
                        if (_this.loadingImg) {
                            loadhtml = '<div class="table-loading"><img src="/newstatic/images/loading.gif"></img></div>';
                            $('#' + _this.div_id).append(loadhtml);
                        }
                        ;
                        return [4 /*yield*/, this.getData(options)];
                    case 1:
                        data = _a.sent();
                        $('#' + this.div_id).empty().append(this.makeTable(data));
                        if (this.onShowComplete) {
                            this.onShowComplete(data);
                        }
                        ;
                        $('.table-loading').css({ 'display': 'none !importannt' });
                        return [2 /*return*/];
                }
            });
        });
    };
    datatable.prototype.getData = function (options) {
        var _a, _b, _c, _d;
        var _this = this;
        var params = this.tabledataurl['params'];
        if (options.sort != undefined) {
            var sortobj = options.sort;
            var nextsort = getSortType(this.this_sort_type);
            this.this_sort_type = nextsort;
            if (sortobj[nextsort])
                params = $.extend(params, (_a = {},
                    _a[sortobj[nextsort].sortkey] = sortobj[nextsort].value,
                    _a));
            if (sortobj.sortname) {
                params = $.extend(params, (_b = {},
                    _b[sortobj.sortname.key] = sortobj.sortname.value,
                    _b));
            }
            if (sortobj.sortname) {
                params = $.extend(params, (_c = {},
                    _c[sortobj.sortname.key] = sortobj.sortname.value,
                    _c));
            }
        }
        if (options.search) {
            params = $.extend(params, options.search);
        }
        if (options.pager) {
            params = $.extend(params, {
                p: options.pager,
                pageNo: options.pager,
                pageNum: options.pager,
                pageNumber: options.pager //比如：新版datacenter
            });
        }
        // 特殊分页字段，支持动态传分页字段名
        // 比如：高管持股页面分页（url: /executive/gdzjc-jzc.html）
        if (_this.pageNoName) {
            params = $.extend(params, (_d = {},
                _d[_this.pageNoName] = options.pager,
                _d));
        }
        return this.getDataAjax(params);
    };
    datatable.prototype.getDataAjax = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            //ajax请求抽出\
            function getDataInfos() {
                if (_this.postUrl) {
                    try {
                        var ajaxfn = {
                            url: url,
                            type: 'POST',
                            timeout: 20000,
                            jsonpCallback: rnd,
                            data: JSON.stringify(params),
                            dataType: "json",
                            contentType: "application/json",
                            error: function (msg) {
                                $('.stockdata #' + _this.div_id).parents('.table-cont').hide();
                            }
                        };
                        // 地址为三期二期的接口，需要传jsonp参数
                        _this.webhostname == 'datainterface' ? (ajaxfn['jsonp'] = 'cb') : undefined;
                        return $.ajax(ajaxfn);
                    }
                    catch (error) {
                        return [];
                    }
                }
                else {
                    try {
                        var dataType = _this.webhostname == 'url' ? 'json' : 'jsonp';
                        var ajaxfn = {
                            url: url,
                            type: 'GET',
                            timeout: 20000,
                            jsonpCallback: rnd,
                            dataType: dataType,
                            data: params,
                            error: function (msg) {
                                // console.log(_this.div_id)
                                $('.stockdata #' + _this.div_id).parents('.table-cont').hide();
                            }
                        };
                        // 地址为三期二期的接口，需要传jsonp参数
                        _this.webhostname == 'datainterface' ? (ajaxfn['jsonp'] = 'cb') : undefined;
                        return $.ajax(ajaxfn);
                    }
                    catch (error) {
                        return [];
                    }
                }
            }
            function hasData(data) {
                if (data == null) {
                    $('#' + _this.div_id).parents('.table-cont').hide();
                }
                else if (data.length <= 0) {
                    // 隐藏对应的table
                    $('#' + _this.div_id).parents('.table-cont').hide();
                }
            }
            var _this, rnd, url, getdatafunction, onecache, dtd;
            var _this_1 = this;
            return __generator(this, function (_a) {
                _this = this;
                rnd = 'datatable' + Math.floor(Math.random() * 10000000 + 1);
                url = webconfig.getWebPath(this.webhostname) + this.tabledataurl['url'];
                getdatafunction = null;
                if (this.initdata) {
                    this.initdata = false;
                    onecache = (function () {
                        if (window.location.search.length > 1) { //判断url?后面是否带有参数
                            return true;
                        }
                        else {
                            return false;
                        }
                    })();
                    if (this.initdataone && onecache) { //如果initdataone&&onecache 则走缓存逻辑:为了处理有些页面带参数和不带参数(首次请求走接口)
                        getdatafunction = getDataInfos();
                    }
                    else {
                        dtd = $.Deferred();
                        getdatafunction = dtd.resolve(window[this.initdataLab]); //抓取页面缓存的数据initdata
                    }
                }
                else { //如不需要缓存逻辑 直接走接口
                    getdatafunction = getDataInfos();
                }
                return [2 /*return*/, getdatafunction.then(function (v) {
                        // 如果api为datacenter的接口数据，返回的数据直接掉result层
                        if (_this_1.webhostname == 'datacenter' || _this_1.webhostname == 'datacentertest') {
                            v = v.result;
                        }
                        // 如果api为data的接口数据，返回的数据用re
                        if (_this_1.webhostname == 'url') {
                            v.data = v.re ? v.re : v.data;
                        }
                        if (_this_1.enabled_pager && v) {
                            if (v.pages > 1) {
                                // 如果是股市日历相关分页
                                _this.pager(v.pages * 50, params[_this.pageNoName || 'pageNo']);
                            }
                            else {
                                // 如果是普通分页
                                _this.pager(v.hits, params[_this.pageNoName || 'pageNo']);
                            }
                            if (v.data && v.data != [] && (v.TotalPage > 1 || v.pages > 1) && v.data.length > 0) {
                                $('#' + _this_1.pager_id).show();
                            }
                            else {
                                $('#' + _this_1.pager_id).hide();
                            }
                        }
                        // 如果是api为dcfmurl的接口数据，返回的数据要处理一下
                        if (_this_1.webhostname == 'dcfmurl' && !v.font) {
                            hasData(v);
                            if (v.data)
                                return v;
                            return { data: v };
                        }
                        // api为dcfmurl，且部分字段需要转码的情况
                        if (_this_1.webhostname == 'dcfmurl' && v.font) {
                            hasData(v.data);
                            var str_1 = JSON.stringify(v.data);
                            var font = v.font.FontMapping;
                            if (font) {
                                font.map(function (item) {
                                    str_1 = str_1.replace(new RegExp(item.code, "g"), item.value);
                                });
                            }
                            return { data: JSON.parse(str_1) };
                        }
                        // 如果是api为datainterface的接口数据，数据返回为空的时候需要特殊处理
                        if (_this_1.webhostname == 'datainterface') {
                            if (v.data[0].stats == false) {
                                return [];
                            }
                        }
                        v ? hasData(v.data) : hasData(v);
                        return v;
                    })];
            });
        });
    };
    ;
    //生成表格头部
    datatable.prototype.makeTableHead = function (data) {
        var _this_1 = this;
        var _this = this;
        //表格头部
        var table_html_thead = $("<thead></thead>");
        var thead_tr1 = $('<tr></tr>');
        var thead_tr2 = $('<tr></tr>');
        var need_theadfix = isFixThead(this.tablecolumns); //判断是否需要第一层thead
        var ctheadfix = ''; //当前的theadfix
        this.tablecolumns['config'].forEach(function (configitem, index) {
            var thead_th = $('<th></th>');
            if (configitem.width != undefined) {
                thead_th.attr('width', configitem.width + 'px');
            }
            if (configitem.paramname != undefined) { //给当前排序标签添加name
                thead_th.attr('data-name', configitem.paramname);
            }
            //排序
            if (configitem.sort != undefined) {
                var sorthtml_1 = $('<a target="_self" href="javascript:;">' + configitem.th({ data: data }) + '</a>');
                //给头部th 加icon
                if (configitem.icons != undefined) {
                    sorthtml_1.append('<span class="icon icon_' + configitem.icons.name + ' vbottom" title="' + configitem.icons.title + '"></span>');
                }
                var defaultsortType = configitem.defaultsortType; //默认排序类型
                if (defaultsortType != undefined && !_this.curSortParam) { //默认排序只执行第一次
                    if (defaultsortType == 'asc') {
                        sorthtml_1.append('<span class="icon icon_asc sorticon"></span>');
                    }
                    else if (defaultsortType == 'desc') {
                        sorthtml_1.append('<span class="icon icon_desc sorticon"></span>');
                    }
                }
                ;
                var sortnamename = configitem.paramname;
                if (sortnamename && _this.curSortParam == sortnamename) { //判断是否是当前排序字段
                    if (_this_1.this_sort_type == 'asc') {
                        sorthtml_1.append('<span class="icon icon_asc sorticon"></span>');
                    }
                    else if (_this_1.this_sort_type == 'desc') {
                        sorthtml_1.append('<span class="icon icon_desc sorticon"></span>');
                    }
                    //控制浮动表头的样式切换 
                    if (_this.floathead) {
                        var floatTableTh = $('#' + _this.div_id + 'float').find('th');
                        floatTableTh.each(function (index, el) {
                            if ($(this).data('name') == _this.curSortParam) {
                                $(this).find('a').empty().append(sorthtml_1.clone(true));
                            }
                            else {
                                $(this).find('.sorticon').remove();
                            }
                        });
                    }
                    ;
                }
                ;
                thead_th.append(sorthtml_1);
                sorthtml_1.on('click', function () {
                    if (_this.curSortParam != $(this).parent().data('name')) {
                        _this.this_sort_type = 'default';
                    }
                    ; //如果不是当前排序字段，则将排序类型初始化
                    _this.curSortParam = $(this).parent().data('name'); //存储全局 记录当前排序字段
                    // if (defaultsortType && defaultsortType != 'default'){  //处理带默认排序的排序类型
                    //   _this.this_sort_type = defaultsortType
                    //   configitem.defaultsortType = false
                    //   defaultsortType = false
                    // }
                    _this.showTable({
                        sort: configitem.sort,
                        pager: 1
                    });
                });
            }
            else {
                thead_th.append(configitem.th({
                    data: data
                })); //整个传入，具体地方具体处理
                //给头部th 加icon
                if (configitem.icons != undefined) {
                    thead_th.append('<span class="icon icon_' + configitem.icons.name + ' vbottom" title="' + configitem.icons.title + '"></span>');
                }
            }
            //是否多级头部处理 
            if (need_theadfix) {
                if (configitem.theadfix != undefined) {
                    //thead_tr2.append(thead_th)
                    if (configitem.theadfix != ctheadfix) {
                        var fixcount = getSameTheadFix(_this_1.tablecolumns['config'], index);
                        var theadfixth = $('<th colspan="' + fixcount + '">' + _this_1.tablecolumns['theadfix'][configitem.theadfix](data) + '</th>');
                        //thead_th.attr('colspan', fixcount)
                        ctheadfix = configitem.theadfix;
                        thead_tr1.append(theadfixth);
                    }
                    thead_tr2.append(thead_th);
                    //thead_tr1.append(thead_th)
                }
                else {
                    thead_th.attr('rowspan', 2);
                    thead_tr1.append(thead_th);
                }
            }
            else {
                thead_tr1.append(thead_th);
            }
        });
        if (need_theadfix) {
            table_html_thead.append(thead_tr1).append(thead_tr2);
        }
        else {
            table_html_thead.append(thead_tr1);
        }
        return table_html_thead;
    };
    ;
    datatable.prototype.makeTable = function (data) {
        var _this = this;
        var table_html = $('<table class=' + this.tableclass + '><thead></thead><tbody></tbody></table>');
        var table_html_thead = _this.makeTableHead(data);
        $('thead', table_html).replaceWith(table_html_thead);
        if (data && data.data != undefined && data.data.length > 0) {
            data.data.forEach(function (v, index) {
                //特殊逗号分开数据的接口先转换为对象，省去每次split
                if (typeof (v) == 'string') {
                    var splitstr = ',';
                    var arr = v.split(splitstr);
                    var model_1 = {};
                    arr.forEach(function (s, index) {
                        model_1['f' + index] = s;
                    });
                    v = model_1;
                }
                // 数据为对象才添加v.index，不然有的string数据报错
                typeof (v) == 'object' ? (v.index = index + Number(data.pageNo ? (data.pageNo - 1) * 50 : '')) : '';
                var tr = $('<tr></tr>');
                //表格内容
                _this.tablecolumns['config'].forEach(function (configitem) {
                    var _a, _b;
                    var isdefaultsort = configitem.defaultsortType && configitem.defaultsortType != 'default';
                    var iscursort = _this.curSortParam == configitem.paramname && _this.this_sort_type != 'default';
                    var td = {};
                    if (_this.curSortParam) {
                        td = iscursort ? $('<td class="col"></td>') : $('<td></td>');
                    }
                    else {
                        td = isdefaultsort ? $('<td class="col"></td>') : $('<td></td>');
                    }
                    td.html(configitem.td(v, (_b = (_a = _this === null || _this === void 0 ? void 0 : _this.tablepager) === null || _a === void 0 ? void 0 : _a.ops) === null || _b === void 0 ? void 0 : _b.currentpage));
                    tr.append(td);
                });
                $('tbody', table_html).append(tr);
            });
        }
        else {
            var len = this.tablecolumns['config'].length;
            var tr = $('<tr><td colspan=' + len + ' class="none">暂无数据</td></tr>');
            $('tbody', table_html).append(tr);
        }
        return table_html;
    };
    datatable.prototype.pager = function (sum, currentPage) {
        var _this = this;
        if (_this.tablepager == null) {
            _this.tablepager = new pager_1["default"]({
                pagerid: this.pager_id,
                currentpage: currentPage ? currentPage : 1,
                pagesize: 50,
                allcount: sum,
                href: '',
                onClick: function (index) {
                    _this.goPager(index);
                }
            });
        }
        else {
            _this.tablepager.ops.allcount = sum;
            _this.tablepager.ops.currentpage = currentPage ? currentPage : 1;
            _this.tablepager.show();
        }
        // _this.tablepager.show()
    };
    datatable.prototype.goPager = function (toindex) {
        return __awaiter(this, void 0, void 0, function () {
            var _top;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        //是否开启加载滚动
                        if (this.loadscroll && $('.framecontent').length) {
                            _top = $('.framecontent').offset().top;
                            $("html,body").animate({ "scrollTop": _top });
                        }
                        return [4 /*yield*/, this.showTable({
                                pager: toindex
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    datatable.prototype.search = function (searchobj) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.showTable({
                            search: searchobj
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    //生成浮动表头
    datatable.prototype.makeFloatHead = function () {
        var _this = this;
        $('#' + this.div_id + 'float').empty().remove();
        var floatTable = $('<div id="' + this.div_id + 'float" class="table-float-head"><table class="floathead table-model" style="margin-top:0;width:865px"><thead></thead></table></div>');
        var _thead = $('#' + this.div_id + ' table thead');
        $('thead', floatTable).append($('#' + this.div_id + ' table thead').clone(true));
        $('tr', _thead).find('th').each(function (index, el) {
            $('tr', floatTable).find('th').eq(index).width($(el).width());
        });
        $('#' + this.div_id).before(floatTable);
        $(window).scroll(function () {
            var _tableheight = $('#' + _this.div_id).height();
            var _offsettop = $('#' + _this.div_id).offset().top;
            var _scrollheight = $(window).scrollTop();
            var floathtml = $('#' + _this.div_id + 'float');
            if (_scrollheight > _offsettop) {
                floathtml.css({ 'display': 'block' });
                if (_scrollheight > (_offsettop + _tableheight) - 50) {
                    floathtml.css({ 'display': 'none' });
                }
            }
            else {
                floathtml.css({ 'display': 'none' });
            }
            // X轴滚动时动态设置left值
            var _scrollleft = $(window).scrollLeft();
            floathtml.css({ 'left': (_scrollleft ? 135 - _scrollleft : 'auto') });
        });
    };
    ;
    return datatable;
}());
exports["default"] = datatable;
